import { sanitize } from "@/utils/sanitize.ts";
import Balancer from "react-wrap-balancer";

export const HTMLBalancer = (
  html: string,
  as: string | undefined = undefined,
) => {
  const sanitized = sanitize(html);
  const innerContent = sanitized.replace(
    /^<([a-z][a-z0-9]*)([^>]*)>(.*)<\/\1>$/i,
    "$3",
  );
  return (
    <Balancer dangerouslySetInnerHTML={{ __html: innerContent }} as={as} />
  );
};

export const HTML = (html: string, as: "div" | "p" = "p") => {
  const sanitized = sanitize(html, { addAttributes: ["target"] });
  const Component = as;
  const innerContent = sanitized.replace(
    /^<([a-z][a-z0-9]*)([^>]*)>(.*)<\/\1>$/i,
    "$3",
  );
  return <Component dangerouslySetInnerHTML={{ __html: innerContent }} />;
};
